module.exports = __webpack_public_path__ + "img/dec.e02bf420.png";